'use client';

import Image from 'next/image';
import { FC, useMemo, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Flex, Text, Skeleton, useColorMode, Link } from '@eqi-investimentos/react';
import { CardOpportunityProps } from '../../interface/secondaries';
import { AssetsRecommendationData } from '@/modules/Asset/interface/Recommendation';
import { PATHS } from '@/config/paths';
import { useGetAssetsRecommendations } from '@/modules/Asset/http/client/useGetAssetsRecommendations';
import { WidgetContainer } from '@/components/molecules/Widget/Container';
import { CardOpportinityProduct } from '../CardOpportunityProduct';
import { DrawerDetailsOpportunity } from '../DrawerDetailsOpportunity';
export const OpportunitiesWalletWidget: FC<OpportunitiesWalletWidgetProps> = ({
  isHub,
  handleChangeTab
}) => {
  const {
    colorMode
  } = useColorMode();
  const isDarkMode = colorMode === 'dark';
  const {
    t: i18n
  } = useTranslation('common');
  const [opportunityToView, setOpportunityToView] = useState<CardOpportunityProps>({});
  const {
    data: recommendationList = [],
    isFetching
  } = useGetAssetsRecommendations();
  const listMapped = useMemo(() => organizeMapFields(recommendationList ?? []), [recommendationList]);
  const handleOpenDetails = (data: CardOpportunityProps) => {
    setOpportunityToView(data);
    window.dispatchEvent(new Event(`open-chakra-modal-${OPPORTUNITY_SECONDARIES_WALLET_DETAILS_DRAWER_ID}`));
  };
  if (!recommendationList.length) return <></>;
  return <Flex id="widget-opportunities-wallet" direction="column" data-sentry-element="Flex" data-sentry-component="OpportunitiesWalletWidget" data-sentry-source-file="index.tsx">
      <DrawerDetailsOpportunity id={OPPORTUNITY_SECONDARIES_WALLET_DETAILS_DRAWER_ID} data={opportunityToView} data-sentry-element="DrawerDetailsOpportunity" data-sentry-source-file="index.tsx" />

      <Flex position="relative" w="9.375rem" h="2.6875rem" alignSelf="flex-start" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Image src={['/assets/eqi_research.svg', '/assets/eqi_research_dark.svg'][Number(isDarkMode)]} width={150} height={43} alt="logo eqi research logo mais text em verde a direita" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </Flex>

      <WidgetContainer containerId={WIDGET_OPPORTUNITIES_WALLET_ID} showTitles={false} buttonLink={PATHS?.investments.index} containerTitleProps={{
      h: '2.5rem'
    }} containerSxProps={{
      '& .swiper-slide': {
        _last: {
          pr: '2xl'
        }
      },
      '& > div > div': {
        _first: {
          pr: '2xl'
        }
      }
    }} customTitle={<Flex flexDir="column" alignItems="start" gap="m" pb="xl">
            <Flex gap="l">
              <Text size="2xl">
                {i18n(`widgets.secondariesOpportunitiesWallet.title`)}
              </Text>
              <Flex as={Link} href={isHub ? '#' : PATHS?.investments?.index} w="auto" h="auto" onClick={e => {
          if (isHub && handleChangeTab) {
            e.stopPropagation();
            handleChangeTab();
          }
        }} alignItems="center" justifyContent="center">
                <Text size="l" color="content.brand" textTransform="capitalize">
                  {i18n(`attributes.seeAll`)}
                </Text>
                <ChevronRight boxSize="1.25rem" color="content.brand" />
              </Flex>
            </Flex>
          </Flex>} data-sentry-element="WidgetContainer" data-sentry-source-file="index.tsx">
        {isFetching ? Array.from({
        length: 10
      }).map((_, idx) => <Skeleton key={idx} w="21.75rem" h="18.75rem" borderRadius="xs" />) : listMapped.map(card => {
        return <Flex key={card.id} w="21.75rem" sx={{
          '& > div': {
            minH: '23.75rem'
          }
        }}>
                  <CardOpportinityProduct data={{
            ...card,
            type: 'wallet'
          }} isHub={false} handelViewDetails={handleOpenDetails} />
                </Flex>;
      })}
      </WidgetContainer>
    </Flex>;
};
interface OpportunitiesWalletWidgetProps {
  isHub?: boolean;
  handleChangeTab?: () => void;
}
const WIDGET_OPPORTUNITIES_WALLET_ID = 'opportunities_wallet_widget_id';
export const OPPORTUNITY_SECONDARIES_WALLET_DETAILS_DRAWER_ID = 'opportunity_secondaries_wallet_details_drawer_id';

//  TO DO - mocked ultil provides final endpoint of that
const organizeMapFields = (data: AssetsRecommendationData[]) => {
  if (!data.length) return [];
  return data.map(item => ({
    id: item.id,
    subject: item.title,
    categories: item.categories,
    profile: 'Conservador',
    return_last_year: 2.6,
    benchmark: -1.5,
    program: item.program
  }));
};